import Aos from 'aos'
import "aos/dist/aos.css"
import React, { useEffect } from 'react'
import Footer from '../Footer'
import Profile from '../Profile'

const Team = () => {
  useEffect(() => [
    Aos.init({duration:2000})
  ],[])
  return (
      <>
    <div className='teamheader'><p><b>Team ACM RSCOE</b></p>
    <br/>
          <img style={{width:"80%"}} alt='header-img' src='./Images/team/teamacm.jpg'></img>
        </div>  
    <Profile />
    <Footer />
    </>
  )
}

export default Team